import ConfirmationModal from "../ConfirmationModal";
import { showErrorMessage, showSuccessMessage } from "helpers/toastMessage";
import { useToggle } from "usehooks-ts";
import { useCallback } from "react";
import { factoringDebtorRelation } from "services/api/haulpay";
import { useMutation } from "@tanstack/react-query";

type Props = {
  noaActive: boolean;
  noaSent: boolean;
  noaRequested: boolean;
  creditApproved: string;
  debtorId: string;
  factoringId: string;
};

const NOAStatus = (relation: Props) => {
  const [sendNOAModalOpen, toggleSendNOAModalOpen] = useToggle(false);
  const mutation = useMutation(
    async ({ clientId, debtor }: { clientId: string; debtor: string }) =>
      factoringDebtorRelation({
        client_id: clientId,
        auto_send_noa: true,
        debtor: debtor
      }),
    {
      onSuccess: () => {
        showSuccessMessage("NOA has been sent.");
        toggleSendNOAModalOpen();
      },
      onError: () => {
        showErrorMessage("Error while sending NOA.");
      }
    }
  );

  const handleButtonClick = useCallback(() => {
    mutation.mutate({ clientId: relation?.factoringId, debtor: relation?.debtorId });
  }, [mutation, relation?.debtorId, relation?.factoringId]);

  if (relation.noaActive) {
    return <span className="text-green-500 uppercase text-xs">Placed (Active)</span>;
  }

  if (relation.noaSent) {
    return <span className="text-blue-500 uppercase text-xs">Sent (Pending)</span>;
  }

  if (relation.noaRequested) {
    return <span className="uppercase text-amber-800 text-xs">Request Sent</span>;
  }

  if (relation.creditApproved === "Approved") {
    return (
      <>
        <button
          type="button"
          className="text-red-500 uppercase cursor-pointer hover:text-red-600 text-xs"
          onClick={toggleSendNOAModalOpen}>
          Not Sent (click to Send)
        </button>
        <ConfirmationModal
          content="Would you like to place a Notice of Assignment to enable payment financing for this debtor/customer?"
          isConfirmModalOpen={sendNOAModalOpen}
          toggleConfirmModal={toggleSendNOAModalOpen}
          onOK={handleButtonClick}
          isLoading={mutation?.isLoading}
        />
      </>
    );
  }

  return <span className="text-red-500 uppercase text-xs">Not Sent</span>;
};

export default NOAStatus;
